import Swiper from 'swiper/dist/js/swiper.min'


  // [BRYAN] - Swiper su Sage va solo su window Load
$( window ).load(function() {

  new Swiper('.swiper-container', {
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
  });

});




// WEBPACK FOOTER //
// ./scripts/components/_swiper.js